import React from 'react';
import PropTypes from 'prop-types';

import FavoriteIcon, { favoriteActionTitle } from '../FavoriteIcon';
import { IconToggle } from './styles';

const ICON_SIZE = 20;

/**
 * A hero page's favorite control. It persists immediately rather than through
 * the page's draft/Save flow, for read mode only.
 */
export default function FavoriteButton({ isFavorite, onToggle }) {
  return (
    <IconToggle type="button" onClick={onToggle} title={favoriteActionTitle(isFavorite)}>
      <FavoriteIcon isFavorite={isFavorite} size={ICON_SIZE} />
    </IconToggle>
  );
}

FavoriteButton.propTypes = {
  isFavorite: PropTypes.bool,
  onToggle: PropTypes.func,
};

FavoriteButton.defaultProps = {
  isFavorite: false,
  onToggle: null,
};
